
import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setAddToCart, setloading, seterror, resetAddToCart
} from "../reducers/addToCartReducer";
import { toast } from "react-toastify";

const addCourseToCart = (data: any, token: any ) => async (dispatch: Dispatch) => {    
    dispatch(setloading(true));
    let payload = JSON.stringify({
        "course_id": data
    });
    try {
        const result = await api
            .post(
                `orders/cart/add-to-cart/`,
                    payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`
                    },
                }
            )

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                toast.success(result?.data?.message);
                dispatch(setAddToCart({ ...result.data }));
            }
            else if(result.data?.status === 400){
                toast.error(result.data?.message);
                dispatch(seterror(result.data?.message));

            }
            else {
                toast.error(result.data?.message ?? "Something Went Wrong!");
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    }
    catch (error: any) {
        toast.error(error.response.data.message);
        dispatch(seterror(error.response.data.message));
    }
}

export { addCourseToCart, resetAddToCart }
